"use client";
// or remove this if not using Next.js app router

import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { useThemeContext } from "../../context/ThemeContext";

export default function ThemeToggle() {
  const { selectedTheme, setSelectedTheme, themeOptions } = useThemeContext();

  return (
    <Menu as="div" className="relative inline-block text-left">
      {/* Menu button */}
      <div>
        <Menu.Button
          className="inline-flex items-center 
                     rounded-md bg-[var(--color-primary)] px-3 py-2 
                     text-sm font-medium text-[var(--color-text-on-primary)]
                     hover:bg-[var(--color-primary-dark)]
                     focus:outline-none focus-visible:ring-2 
                     focus-visible:ring-white focus-visible:ring-opacity-75
                     transition-colors"
        >
          Theme
          <ChevronDownIcon
            className="w-4 h-4 ml-1 text-[var(--color-text-on-primary)]"
            aria-hidden="true"
          />
        </Menu.Button>
      </div>

      {/* Menu items */}
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className="absolute left-0 mt-2 w-48 origin-top-right 
                     rounded-md shadow-lg ring-1 ring-black ring-opacity-5
                     bg-[var(--color-neutral-light)] focus:outline-none z-50"
        >
          {themeOptions.map((theme) => (
            <Menu.Item key={theme._id}>
              {({ active }) => (
                <button
                  onClick={() => setSelectedTheme(theme._id)}
                  className={`
                    ${
                      active
                        ? "bg-[var(--color-primary-light)] text-[var(--color-text-on-primary)]"
                        : "text-[var(--color-text)]"
                    } 
                    group flex w-full items-center px-4 py-2 text-sm 
                    transition-colors
                  `}
                >
                  {theme.label}
                </button>
              )}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
